import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import { QueInfo, QueNumber, Question, QueTitle } from "./QueTexts";
import { Info } from "../svg/other";
import  {OurProcess}  from "../../question_components/container/OurProcess";

export function QueHeader({
  progress,
  title,
  number,
  question,
  info,
  children,
}) {
  return (
    <header className="que-header">
      <div className="que-header-wrapper">
        <div className="que-title-container">
          <QueTitle>{title}</QueTitle>
          <ProgressBar
            className="que-progress-bar"
            bgColor="#ffca28"
            labelColor="#000"
            completed={progress}
            height={22}
            labelAlignment="center"
            transitionTimingFunction="linear"
          />
        </div>
        <div className="desktop-view">
          <OurProcess />
        </div>
        <div className="que-wrapper">
          {number && <QueNumber>{number}</QueNumber>}

          <Question>{question}</Question>
          {info && (
            <QueInfo>
              <Info />
              {info}
            </QueInfo>
          )}
        </div>
      </div>
      <div>{children}</div>
    </header>
  );
}
